import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import common from './modules/common'
import tags from './modules/tags'
import dict from './modules/dict'
import designer from './modules/designer'
import getters from './getters'

Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    publicOption: {
      height: 'auto',// 表格高度
      calcHeight: 100,// Avue 文档项；@/mixins/crud-mixins 劫持 getTableHeight 时未参与运算，单页请用 tableCalcHeight 或固定 height
      tip: false,// 弹框文字提示
      searchShow: true,//首次加载是否显示搜索
      searchMenuSpan: 6, // 搜索条件所占比例，一行为24。
      searchLabelWidth: 110,// 搜索条件文本宽度
      span: 12, // 详情、新增、修改页面所占比例，一行为24。
      searchSpan: 6,
      labelWidth: 110,// 详情、新增、修改页面文本所占宽度。
      // border: true, // 表格边框（与 nx-web-base publicOption 一致，全局纵向分隔线）
      // card: true, // 列表外包一层 el-card，配合 avue-ui 合一外壳样式
      index: false,// 索引是否显示
      indexLabel: '序号', // 索引列的文字 默认为#
      viewBtn: true,// 查看按钮
      selection: false, // 是否开启选择
      selectionWidth: 40,
      dialogClickModal: false,
      headerAlign: 'center',
      align: 'center',
      dialogDrag: true, //开启对话框拖动
      menuWidth: 220, //操作列宽度
      searchMenuPosition: 'right', //查询按钮靠右
      addBtnText: '新增',
      cancelBtnText: "关闭",
      searchFilterDic: true, // 不回传搜索label
      filterDic: true,
      viewBtnText: "详 情",
      viewTitle: "详 情",
      editBtnText: "编 辑",
      editTitle: "编 辑",
      editBtnIcon: "-",
      viewBtnIcon: "-",
      delBtnIcon: "-",
      gridBtn: false, // 关闭卡片模式切换按钮
      searchBtnText: "查询",
      emptyBtnText: "重置",
      emptyBtnIcon: "el-icon-refresh",
      stripe: false,
      menuClassName:'menuClass',
      menuLabelClassName:'menuLabelClass',
      // 为 true 时跳过 applyAvueTextInputLimits 对 column 的默认 maxlength 合并（见 src/util/apply-avue-text-limits.js）
      cancelDefaultTextLimit: false,
    },
    formOption:{
      labelWidth: 120
    }
  },
  modules: {
    user,
    common,
    tags,
    dict,
    designer
  },
  getters,
  mutations: {

  },
})

export default store
